import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HttpCancelService {
    private cancelPendingRequests$ = new Subject<void>();

    constructor() {
    }

    /** Cancels all pending Http requests. */
    public cancelPendingRequests(toLogin?: boolean) {
        this.cancelPendingRequests$.next();
        if (toLogin) {
            setTimeout(() => {
                this.cancelPendingRequests$.next();
            }, 500);
            setTimeout(() => {
                this.cancelPendingRequests$.next();
            }, 1000);
        }
    }

    public onCancelPendingRequests() {
        return this.cancelPendingRequests$.asObservable()
    }

}
